import React from 'react';
import moment from 'moment';
import Chart from 'react-apexcharts';

import * as S from '../../styles';

interface IProps {
  widthGraphic?: number;
  heightGraphic?: number;
  categories: string[];
  series: {
    name: string;
    data: number[];
  }[];
  subTitle?: string;
}

const BoxStore: React.FC<IProps> = ({
  categories,
  series,
  widthGraphic = 760,
  heightGraphic = 300,
  subTitle = '',
}) => {
  const buildCategories = () => {
  const hasCategories = Array.isArray(categories) && categories.length > 0;

  return {
    chart: {
      width: '100%',
      height: 300,
      type: 'bar',
    },
    plotOptions: {
      bar: {
        columnWidth: '50%',
        distributed: true,
        borderRadius: hasCategories ? 10 : 4,
        dataLabels: {
          position: 'top',
        },
      },
    },
    dataLabels: {
      enabled: true,
      offsetY: -25,
      style: {
        fontSize: '12px',
        colors: ['#304758'],
      },
    },
    legend: {
      show: false,
    },
    xaxis: {
      categories: hasCategories ? categories : ['Sem dados'],
      labels: {
        show: true,
        rotate: -90,
        hideOverlappingLabels: true,
        showDuplicates: false,
        trim: false,
        minHeight: 100,
        maxHeight: 120,
        style: {
          colors: ['#304758'],
          fontSize: '12px',
          fontWeight: 400,
          cssClass: 'apexcharts-xaxis-label',
        },
      },
      axisBorder: { show: true },
      axisTicks: { show: true },
      tooltip: { enabled: true },
    },
    yaxis: {
      axisBorder: { show: true },
      axisTicks: { show: true },
      labels: {
        show: false,
        formatter(val: number) {
          return val;
        },
      },
    },
    theme: {
      monochrome: {
        enabled: true,
        shadeTo: 'light',
        color: '#2d1ba7',
        shadeIntensity: 0.6,
      },
    },
  } as any;
};


  const buildSeries = () => {
  if (!Array.isArray(series) || series.length === 0) {
    return [{ name: 'Lojas', data: [0] }];
  }

  return series.map((s) => ({
    name: s?.name ?? 'Lojas',
    data: Array.isArray(s?.data) && s.data.length > 0 ? s.data : [0],
  }));
};

  return (
    <>
      <S.BoxDetails>
        <header>
          <h2>Lojas</h2>
          <span>
            {subTitle !== ''
              ? subTitle
              : `Última atualização: hoje às ${moment().format(
                  'hh:mm',
                )}pm. Referente a data de ontem`}
          </span>
        </header>
        <S.ItemGraphic>
          <Chart
            options={buildCategories()}
            series={buildSeries()}
            type="bar"
            height={heightGraphic}
            width={widthGraphic}
          />
        </S.ItemGraphic>
      </S.BoxDetails>
    </>
  );
};

export default BoxStore;
